/**
 * Global header "Call History" button — sits left of the notification bell so
 * every logged-in user can reach it, regardless of role. Some agents don't get
 * a "My Chats" menu item at all (e.g. cohort/repeat agents), which used to
 * leave them with no way to open their call history. Moved here from My Chats
 * on 2026-08-31 so it's reachable from every page.
 */
import React, { useState } from 'react';

// material-ui
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, Box, ButtonBase, Tooltip } from '@material-ui/core';

// assets
import { IconHistory } from '@tabler/icons';

import CallHistoryDialog from '../../../menu-items/Dashboard/CallHistoryDialog';

const useStyles = makeStyles((theme) => ({
  headerAvatar: {
    ...theme.typography.commonAvatar,
    ...theme.typography.mediumAvatar,
    transition: 'all .2s ease-in-out',
    background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
    color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
    '&:hover': {
      background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
      color: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.light,
    },
  },
}));

export default function CallHistoryButton() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Box sx={{ mr: 1 }}>
        <Tooltip title="Call History">
          <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
            <Avatar variant="rounded" className={classes.headerAvatar} onClick={() => setOpen(true)} color="inherit">
              <IconHistory stroke={1.5} size="1.3rem" />
            </Avatar>
          </ButtonBase>
        </Tooltip>
      </Box>
      <CallHistoryDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
